export default __webpack_public_path__ + "static/media/nintendo.2656f1fc.svg";